
import { Vue, Component } from 'vue-property-decorator'
import User from '@/types/user'

@Component({
  components: {}
})

export default class UserCreateDetailsTab extends Vue {
  settings = {
    routeNames: { list: 'users', show: 'userShow', edit: 'userEdit' },
    routeParamKey: 'userId',
    functionNames: { setCurrent: 'setCurrentUser', save: 'saveUser' },
    getterNames: { current: 'currentUser', loading: 'loadingUser', errors: 'userErrors' }
  }

  get currentItem () : User {
    return this.$store.getters[this.settings.getterNames.current]
  }

  get errors () : { [key:string]: string[] } {
    return this.$store.getters[this.settings.getterNames.errors]
  }
}
